<template>
  <div class="app-loader-overlay">
    <div class="app-loader-box">
      <div class="spinner"></div>
      <div v-if="text" class="app-loader-text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppLoader",
  props: {
    text: { type: String, default: "" }
  }
};
</script>

<style scoped>
.app-loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.app-loader-box {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  gap: 12px;
}
.spinner {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 3px solid #d9e6f7;
  border-top-color: #18417e;
  animation: spin 0.9s linear infinite;
}
.app-loader-text {
  font-weight: 700;
  color: #18417e;
  font-size: 14px;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
